import { render, staticRenderFns } from "./Button.vue?vue&type=template&id=3e8d08ce&functional=true"
var script = {}
import style0 from "./Button.vue?vue&type=style&index=0&id=3e8d08ce&prod&lang=stylus&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  injectStyles,
  null,
  null
  
)

export default component.exports